import { SVGProps, Ref, forwardRef } from 'react';

export const QuestionCircleOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M6.865 5.999c0-.529.43-.967 1.133-.967S9.131 5.47 9.131 6c0 .271-.07.414-.146.517-.099.13-.239.239-.482.416l-.025.018c-.214.156-.518.376-.753.69-.267.356-.427.796-.427 1.358h1.4c0-.272.07-.414.147-.517.098-.131.238-.24.481-.417l.025-.018c.214-.155.518-.376.754-.69.266-.355.426-.796.426-1.357 0-1.472-1.237-2.367-2.533-2.367S5.465 4.527 5.465 6z"
                        fill="currentColor"
                    />
                    <path d="M8.931 10.83a.933.933 0 1 0-1.866 0 .933.933 0 0 0 1.866 0" fill="currentColor" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M.5 8C.5 4.25 2.375.5 8 .5s7.5 3.75 7.5 7.5-1.875 7.5-7.5 7.5S.5 11.75.5 8m1.4 0c0-1.667.42-3.184 1.316-4.26C4.076 2.709 5.524 1.9 8 1.9s3.925.809 4.784 1.84C13.68 4.816 14.1 6.333 14.1 8s-.42 3.184-1.316 4.26c-.86 1.031-2.308 1.84-4.784 1.84s-3.925-.809-4.784-1.84C2.32 11.184 1.9 9.667 1.9 8"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
QuestionCircleOutlinedSize16Glyph.displayName = 'QuestionCircleOutlinedSize16Glyph';
